import { viperApi, clinicalApiPath } from '@/services/viper-api'
import _ from 'lodash'

export const reminderService = {
  basePath: `${clinicalApiPath}/reminders`,

  update(reminderId, params) {
    return viperApi.put(this.basePath + `/${reminderId}`, params)
  },

  setViewed(requests) {
    _.forEach(requests, it => (it.viewed = true))
    return viperApi.put(this.basePath, requests)
  },

  setRead(requests) {
    _.forEach(requests, it => (it.read = true))
    return viperApi.put(this.basePath, requests)
  },

  create(reminder) {
    return viperApi.post(this.basePath, reminder)
  },

  delete(reminderId) {
    return viperApi.delete(this.basePath + `/${reminderId}`)
  },

  getReminders() {
    return viperApi.get(this.basePath + '/notifications')
  },

  getTrialPatientReminders(trialId, patientId) {
    return viperApi.get(this.basePath + `/trial/${trialId}/patient/${patientId}`)
  }
}
